var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('app-nav'),_c('app-slides'),_c('app-features',{staticClass:"mt"}),_c('app-footer',{staticStyle:{"margin-top":"30px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }